import React, { useMemo, useState } from 'react';
import { useMediaQuery } from '@material-ui/core';
import { sizes } from '@this/components/shared/atoms/media';

type Props = {
  title: string;
  icon?: React.ReactNode;
  rightSlot?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
};

const HelpAccordion: React.FC<Props> = ({ title, icon, rightSlot, defaultOpen = false, children }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const isMobile = useMediaQuery(`(max-width: ${sizes.spSmall}px)`, { noSsr: true });
  const styles = useMemo(() => getStyles(isMobile), [isMobile]);

  return (
    <div style={styles.container}>
      <div style={styles.bar} onClick={() => setIsOpen(!isOpen)}>
        {icon && <span style={styles.icon}>{icon}</span>}
        <span style={styles.title}>{title}</span>
        {rightSlot}
        <img
          src={isOpen ? '/images/help/chevron_up_icon.svg' : '/images/help/chevron_down_icon.svg'}
          alt={isOpen ? 'chevron up' : 'chevron down'}
          style={styles.chevron}
        />
      </div>
      {isOpen && children}
    </div>
  );
};

function getStyles(isMobile: boolean): { [key: string]: React.CSSProperties } {
  return {
    container: {
      marginTop: 12,
      marginBottom: 24
    },
    bar: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: isMobile ? 'wrap' : 'nowrap',
      gap: isMobile ? '8px 0' : undefined,
      padding: isMobile ? '16px 12px' : 24,
      color: 'white',
      fontSize: isMobile ? 16 : 20,
      fontWeight: 700,
      lineHeight: isMobile ? '22px' : '25px',
      background: '#292c35'
    },
    icon: {
      display: 'inline-flex',
      alignItems: 'center',
      flexShrink: 0,
      marginRight: isMobile ? 4 : 8
    },
    title: {
      minWidth: 0,
      flexShrink: 0
    },
    chevron: {
      marginLeft: 'auto',
      flexShrink: 0
    }
  };
}

export default HelpAccordion;
